
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@/shared/ui/toggle-group.tsx"
import TimelineCard from "./TimelineCard";
import { useState } from "react";
import { getTimelineFilters } from "@/lib/utils";

export interface TimelineElement {
  id: number;
  title: string;
  date: string;
  scheduled: string;
}

type TimelineProps = {
  timeline: {
    post_id: number;
    isPosted: boolean;
    post_title: string;
    posting_date: string;
    platform: string;
  }[];
}

const Timeline = ({ timeline }: TimelineProps) => {

  const [filter, setFilter] = useState<string[]>([])

  const filteredTimeline = timeline.filter(post => filter.includes(post.platform.toLowerCase())).length < 1 ? timeline : timeline.filter(post => filter.includes(post.platform.toLowerCase()))

  const timelineFilters = getTimelineFilters(timeline)

  return (
    <>
      <div className='flex items-center h-[10%] justify-between gap-2'>
        <p className='font-montserrat px-2 pt-3'>Posting Timeline</p>
        <ToggleGroup type="multiple" onValueChange={(values: string[]) => {
          setFilter(values)
        }}>
          {timelineFilters.map(tFilter => (
          <ToggleGroupItem key={tFilter} value={tFilter.toLowerCase()} aria-label={`Toggle ${tFilter.toLowerCase()}`}>
            <img src={`https://cdn.simpleicons.org/${tFilter.toLowerCase().includes("twitter") ? "x" : tFilter.toLowerCase()}` } className="h-3 w-3" />
          </ToggleGroupItem>
          ))}
        </ToggleGroup>
      </div>
      <div className='flex flex-col gap-2 h-[90%] p-2 overflow-auto [&::-webkit-scrollbar]:w-2'>
        {filteredTimeline.map(post => (
          <TimelineCard key={post.post_id}
            posting_date={post.posting_date}
            post_title={post.post_title}
            isPosted={post.isPosted}
            platform={post.platform.toLowerCase()}
          />
        ))}
      </div>
    </>
  )
}

export default Timeline;
